import ArrowForwardIosIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, CardActionArea, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MainCard from './MainCard';

const ProductGraphCrad = ({ Content, sx }) => {
  const theme = useTheme();
  return (
    <MainCard sx={{ '&:hover': { borderColor: theme.palette.primary.main } }}>
      <Box sx={{ ...sx }}>
        <Grid container sx={{ height: '100%', justifyContent: 'space-between' }}>
          <Grid item xs={10}>
            {Content}
          </Grid>
          <Grid
            item
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <ArrowForwardIosIcon sx={{ color: theme.palette.primary.light }} />
          </Grid>
        </Grid>
      </Box>
    </MainCard>
  );
};

export default ProductGraphCrad;
